// src/pages/CaseStudies.tsx
import { useState } from "react";
import { CASE_STUDIES, CaseStudy } from "../data/caseStudies";
import CaseStudiesIndex from "../pages/CaseStudies/CaseStudiesIndex";
import CaseStudyDetail from "../pages/CaseStudies/CaseStudyDetail";

const CaseStudiesPage: React.FC = () => {
  const [selectedId, setSelectedId] = useState<string | null>(
    CASE_STUDIES[0]?.id ?? null
  );

  const selected: CaseStudy | null =
    CASE_STUDIES.find((cs) => cs.id === selectedId) ?? null;

  return (
    <div className="bg-bg pb-16">
      {/* Hero / intro */}
      <section className="py-14 sm:py-16 border-b border-line">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <header className="mb-6">
            <p className="kicker mb-4">Case studies</p>
            <h1 className="font-display text-2xl sm:text-3xl font-semibold text-ink mb-3">
              Selected delivery work and applied R&amp;D.
            </h1>
            <p className="text-sm sm:text-base text-muted max-w-2xl">
              A selection of client delivery work and applied research across
              finance, legal technology, data-intensive operations, and
              robotics. Each case is clearly framed by its delivery context.
            </p>
          </header>

          <div className="flex flex-wrap gap-2">
            <span className="tag-chip">Strategy × Governance × Engineering</span>
            <span className="tag-chip">Regulated &amp; high-stakes environments</span>
          </div>
        </div>
      </section>

      {/* Main layout */}
      <section className="pt-10">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[1.05fr,1.55fr] gap-6 lg:gap-8 items-start">
          <CaseStudiesIndex
            caseStudies={CASE_STUDIES}
            selectedId={selectedId}
            onSelect={setSelectedId}
          />
          <CaseStudyDetail caseStudy={selected} />
        </div>
      </section>
    </div>
  );
};

export default CaseStudiesPage;
